import { Component } from '@angular/core';

import { IToolPanel, IToolPanelParams, GridApi } from 'ag-grid-community';

@Component({
  templateUrl: './tool-panel.component.html',
  styleUrls: ['./tool-panel.component.scss']
})
export class ToolPanelComponent implements IToolPanel {
  public gridApi: GridApi;
  public packageFiles: IPackageFile[];
  public selectedPackageFile: string;
  private loadPackageFile: (url: string) => void;

  agInit(
    params: IToolPanelParams & {
      getPackageFiles: () => IPackageFile[];
      loadPackageFile: (url: string) => void;
    }): void {
    this.gridApi = params.api;
    this.packageFiles = params.getPackageFiles();
    this.selectedPackageFile = this.packageFiles.find((p) => p.default).url;
    this.loadPackageFile = params.loadPackageFile;
  }

  refresh(): void { }

  clearFilters(): void {
    this.gridApi.setFilterModel(null);
    this.gridApi.onFilterChanged();
  }

  expandAll() {
    this.gridApi.expandAll();
  }

  collapseAll() {
    this.gridApi.collapseAll();
  }

  packageFileUpdated(url: string) {
    this.loadPackageFile(url);
  }
}
